import React, { useState } from 'react';
import { IPaymentToken } from 'utils/api/models/payments/paymentTokens';
import { makeStyles } from '@material-ui/core';
import styles from 'assets/jss/material-dashboard-pro-react/views/walletStyle';
import GridItem from 'components/Grid/GridItem';
import Visa from 'assets/img/icons/visa.svg';
import Mastercard from 'assets/img/icons/mastercard.svg';
import { HeadingSBold } from 'components/Typography/Typography';
import { translate } from 'components/Translation';
import Button from 'components/CustomButtons/Button';
import DeleteCardConfirmationDialog from './DeleteCardConfirmationDialog';

// @ts-ignore
const useStyles = makeStyles(styles);

interface ISingleCardProps {
	paymentToken: IPaymentToken;
	removeToken: (last4Digits: string) => void;
}

const SingleCard = ({ paymentToken, removeToken }: ISingleCardProps) => {
	const classes = useStyles();
	const [confirmationDialogOpen, setConfirmationDialogOpen] = useState<boolean>(false);
	const backgroundIcon = paymentToken.cardType === 'VISA' ? Visa : Mastercard;
	const last4Digits = paymentToken.cardNumber.slice(-4);

	const hideConfirmationDialog = () => {
		setConfirmationDialogOpen(false);
	};

	const showConfirmationDialog = () => {
		setConfirmationDialogOpen(true);
	};

	return (
		<GridItem xs={12} sm={4} md={6} lg={4}>
			<div className={classes.singleCardWrapper}>
				<div className={classes.cardContentWrapper}>
					<img src={backgroundIcon} alt="Card background icon" className={classes.backgroundIcon} />
					<div className={classes.cardNumber}>
						<HeadingSBold disableMargin>{last4Digits}</HeadingSBold>
					</div>
				</div>
				<div className={classes.deleteCardButtonWrapper} onClick={showConfirmationDialog}>
					<Button color="tertiary-light">{translate('wallet.delete.card')}</Button>
				</div>
			</div>
			<DeleteCardConfirmationDialog
				isOpen={confirmationDialogOpen}
				hideDialog={hideConfirmationDialog}
				removeToken={() => removeToken(last4Digits)}
			/>
		</GridItem>
	);
};

export default SingleCard;
